module.exports = __webpack_public_path__ + "img/Wp_2042.1933d6fc.png";